import React from 'react';
import clsx from 'clsx';
import styles from './DashboardContainer.module.css';

export interface DashboardContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const DashboardContainer: React.FC<DashboardContainerProps> = ({ className, children, ...props }) => {
  return (
    <div className={clsx(styles.dashboardContainer, className)} {...props}>
      {children}
    </div>
  );
};

export default DashboardContainer;
